import { Button, Card, Drawer } from "antd";
import React, { useEffect, useState } from "react";
import AddSS from "../components/SpecialServices/AddSS";
import { AddonServices } from "../Services/AddonServices";
import TableSS from "../components/SpecialServices/TableSS";
import { notify } from "../customs/NotifyProvider";

const SpecialServices = () => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);
  const [editId, setEditId] = useState(null);

  const getAddonServices = async () => {
    try {
      const request = await AddonServices.getAllAddonServices();
      setData(request.data);

      console.log(request.data);

    } catch (error) {
      console.error(error);

    }
  }

  const handleEdit = (id) => {
    try {
      // const request = await 
      console.log(id);
      setEditId(id);
      setOpen(true);

    } catch (error) {
      console.error(error);

    }
  }
  const handleDelete = async (id) => {
    try {
      const req = await AddonServices.deleteAddonServicesById(id);
      if (req.status) {
        notify.success("success", req.message)
      } else {
        notify.error("Something went wrong!", req.message)
      }
      console.log(id);

    } catch (error) {
      console.error(error);

    }
  }

  useEffect(() => {
    getAddonServices();
  }, [])

  return (
    <>
      <Card
        title="Manage Addon Services"
        extra={
          <Button
            type="primary"
            ghost
            onClick={() => setOpen(true)}
          >
            Create Special Services
          </Button>
        }
      >
        <TableSS data={data}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
        />
      </Card>


      <Drawer
        title={editId ? "Edit Addon Service" : "Create Addon Service"}
        width={520}
        open={open}
        onClose={() => {
          setOpen(false);      // close drawer
          setEditId(null);     // clear editId
        }}
        destroyOnClose
      >
        <AddSS
          closeDrawer={() => {
            setOpen(false);
            setEditId(null);   // ensure data cleared if closing from inside AddSS
          }}
          getAddonServices={getAddonServices}
          editorId={editId}
        />
      </Drawer>
    </>
  );
};

export default SpecialServices;
